import { useMemo } from 'react';

import { getPartOfMap } from '../helpers';

import { useAircrafts } from './useAircrafts';

import type { EPartOfMap } from '#shared';

export const useActualMapParts = () => {
  const aircrafts = useAircrafts();

  const aircraftMapParts = useMemo(
    () =>
      aircrafts.reduce<Set<EPartOfMap>>((acc, a) => {
        a.airports.forEach(airport => {
          if (airport.partOfMap) {
            acc.add(airport.partOfMap);
          }
        });
        if (a.closestAirport) {
          const partOfMap =
            a.closestAirport.Longitude &&
            a.closestAirport.Latitude &&
            getPartOfMap([
              a.closestAirport.Longitude,
              a.closestAirport.Latitude,
            ]);
          if (partOfMap) {
            acc.add(partOfMap);
          }
        }
        return acc;
      }, new Set()),
    [aircrafts],
  );
  return aircraftMapParts;
};
